import { Box, Flex, Heading, Text, Spinner, Tooltip } from '@chakra-ui/react'
import { FC } from 'react'
import CountUp from 'react-countup'
import { HiOutlineExternalLink } from 'react-icons/hi'

import { InfoCardProps } from '@base/@types/components/Layout/Card/Info'

const InfoCard: FC<InfoCardProps> = ({
  title,
  value,
  tooltip,
  icon,
  bg = 'white',
  action,
  decimals,
  isLoading = false,
  noShadow
}) => {
  const getDynamicWidth = (value: number) => {
    const length = value.toLocaleString('pt-BR').length
    if (length <= 10 && title === 'Peso Total') return '250px'
    if (length <= 10 && title.length <= 15) return '195px'
    if (length <= 15) return '250px'
    if (length <= 20) return '300px'
    return '350px'
  }

  return (
    <Box
      role="alert"
      width={getDynamicWidth(Number(value))}
      borderRadius="8px"
      bg={bg}
      boxShadow={noShadow ? 'none' : 'sm'}
      pt={[4, 4, 6]}
      pb={action ? 0 : 6}
    >
      <Flex alignItems="center" justifyContent="flex-start" px={[4, 4, 6]}>
        <Flex
          color="gray.400"
          alignItems="center"
          justifyContent="center"
          fontSize="48px"
        >
          {icon}
        </Flex>
        <Box width="100%" ml={[4, 4, 6]}>
          <Tooltip label={tooltip || ''} placement="top-start">
            <Heading
              textTransform="uppercase"
              fontWeight="600"
              color="gray.400"
              fontSize="12px"
              lineHeight="1.2"
            >
              {title}
            </Heading>
          </Tooltip>
          <Flex alignItems="center">
            {isLoading && <Spinner color="green" size="sm" mr={2} />}
            {decimals ? (
              isLoading ? (
                <CountUp
                  end={Number(value)}
                  decimals={decimals === 1 ? 0 : decimals}
                  decimal=","
                  duration={1}
                  preserveValue
                >
                  {({ countUpRef }) => (
                    <span
                      ref={countUpRef}
                      style={{
                        fontSize: '1.5rem',
                        lineHeight: '1.2',
                        color: 'gray.800',
                        fontWeight: 'bold'
                      }}
                    />
                  )}
                </CountUp>
              ) : (
                <Text
                  fontSize="2xl"
                  lineHeight="1.2"
                  color="gray.800"
                  fontWeight="bold"
                >
                  {value.toLocaleString('pt-BR', {
                    maximumFractionDigits: 2
                  })}
                </Text>
              )
            ) : (
              <>
                {!isLoading && (
                  <Text
                    fontSize="2xl"
                    lineHeight="1.2"
                    color="gray.800"
                    fontWeight="bold"
                  >
                    {value}
                  </Text>
                )}
              </>
            )}
          </Flex>
        </Box>
      </Flex>
      {action && (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          py={4}
          mt={6}
          px={[4, 4, 6]}
          onClick={action}
          borderTop="solid 1px"
          color="green.600"
          borderColor="gray.100"
          fontSize="12px"
          borderEndEndRadius="8px"
          borderEndStartRadius="8px"
          cursor="pointer"
          transition="all ease .3s"
          _hover={{
            bgColor: 'gray.50',
            textDecoration: 'none'
          }}
        >
          <Text>Clique para saber mais</Text>
          <Text>
            <HiOutlineExternalLink size="16px" />
          </Text>
        </Flex>
      )}
    </Box>
  )
}

export default InfoCard
